import TopicDetail from '@components/LocalMerchant/TopicDetail'

export default {
  path: 'topicDetail/:id',
  indexRoute: {
    component: TopicDetail
  },
  stat: '任务中心/首页'
}
